export default function (dom, opts) {
	let options = {
		...opts
	};

	const poster = dom.querySelector('.video__poster');
	const iframe = document.createElement('div')
	const tmpl = dom.querySelector('script[type="text/template"]');
	const videoTeaser = document.body.querySelector('.teaser-grid__video');

	if (!tmpl) {
		return false;
	}
	iframe.innerHTML = tmpl.innerHTML;
	tmpl.parentNode.removeChild(tmpl);

	poster.addEventListener('click', e => {
		e.preventDefault();

		poster.parentNode.replaceChild(iframe, poster);
		try {
			iframe.querySelector('video').play();
		} catch (err) {

		}

		if (videoTeaser) {
			videoTeaser.classList.add('play-teaser-video')
		}

	});
}
